import { Directive, Input } from '@angular/core';
import { ZippyClassDirective } from '@df/legacy/ui/zippy/zippy-class.directive';
import { IZippyChangeEvent, IZippyEvent, ZippyEventType } from '@df/legacy/ui/zippy/zippy.abstract';

/**
 * Creates directive that applies classes to element depending on zippy gruop state.
 *
 * ```html
 * <div zippyGroupClass="active-class second-active-class !inactive-class"></div>
 * ```
 */
@Directive({
    selector: '[zippyGroupClass]',
    standalone: false
})
export class ZippyGroupClassDirective extends ZippyClassDirective {
    /**
     * Group class string
     * @author Maurycy Ornat maurycy@tomandco.co.uk
     */
    @Input()
    set zippyGroupClass(classString: string) {
        this.parse(classString);
    }

    // just to kill parent property
    protected override setZippyClass(classString: string) {}

    /**
     * Event listener calling class to be applied when needed
     * @author Maurycy Ornat maurycy@tomandco.co.uk
     * @param  {IZippyEvent | IZippyChangeEvent} event
     */
    protected override onEvent(event: IZippyEvent | IZippyChangeEvent) {
        if (!event.stopped) {
            if (event.type === ZippyEventType.change) {
                if (this.checkEventMatchGroup(event)) {
                    // if visible we can apply right away
                    this.applyClasses((<IZippyChangeEvent>event).visible || this.isAnyOpen() || false);
                }
            }
        }
    }

    protected override initClasses() {
        this.applyClasses(this.isAnyOpen());
    }

    protected override applyClasses(visible: boolean) {
        if (this.visible !== visible) {
            super.applyClasses(visible);
        }
    }
}
